// Hooks / Node modules / Styles
import { motion } from "framer-motion";

// Reducers / Actions

// Utils / Functions
import { fadeIn } from "src/utils/framer-motion/motion";

// Components

// Sub-Components
import ServiceCard from "./ServiceCard";

// Data / Images / Icons
import { SERVICES } from "src/data/pages/services";

function ServiceCardGroup() {
  return (
    <div className="mt-10 flex flex-wrap gap-5 justify-center">
    {SERVICES.map((service, index) => (
      <motion.div
        variants={fadeIn("right", "spring", index * 0.5, 0.75)}
        key={service.title}
      >
        <ServiceCard
          title={service.title}
          icon={service.icon}
        />
      </motion.div>
    ))}
  </div>
  )
}

export default ServiceCardGroup